const state = {
  active: false
}

const actions = {
  load ({ commit }) {
    commit('load')
  },

  setActive ({ commit }, value) {
    commit('setActive', value)
  }
}

const mutations = {
  setActive (state, value) {
    state.active = value
    console.log(`%c dev mode: ${state.active ? 'ON' : 'OFF'} `, 'color:white; background-color: dodgerblue;')
    localStorage.setItem('dev-mode', value)
  },

  load (state) {
    const devMode = localStorage.getItem('dev-mode') === 'true'
    console.log('Loaded dev mode value: ' + devMode)
    state.active = devMode
  }
}

export const dev = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/dev.module.js